import { AxiosResponse } from "axios";
import { ResponseDTO, ServiceCategory } from "types";
import { ServiceDTO } from "types/DTOs/service/service.dto";
import { get, post, put, del } from "utils";
import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API_URL}/service`;

export const getServiceList = async (
  category?: ServiceCategory
): Promise<AxiosResponse<ResponseDTO<ServiceDTO[]>>> => {
  let url = `${baseUrl}/`;
  if (category) url += `?category=${category}`;
  return get(url);
};

export const getServiceDetail = async (
  serviceId: string
): Promise<AxiosResponse<ResponseDTO<ServiceDTO>>> => {
  const url = `${baseUrl}/${serviceId}`;
  return get(url);
};

export const createService = async (
  title: string,
  description: string,
  price: number,
  category: ServiceCategory,
  externalLink: string,
  durationMinutes: number,
  schedules: { date: string; startTime: string; endTime: string }[],
  images?: string[]
): Promise<AxiosResponse<ResponseDTO<ServiceDTO>>> => {
  return post(baseUrl + "/", {
    title,
    description,
    price,
    category,
    externalLink,
    durationMinutes,
    schedules,
    images: images || [],
  });
};

export const updateService = async (
  serviceId: string,
  title: string,
  description: string,
  price: number,
  category: ServiceCategory,
  externalLink: string,
  durationMinutes: number,
  images?: string[],
  schedules?: { date: string; startTime: string; endTime: string }[]
): Promise<AxiosResponse<ResponseDTO<ServiceDTO>>> => {
  return put(`${baseUrl}/${serviceId}`, {
    title,
    description,
    price,
    category,
    externalLink,
    durationMinutes,
    images: images || [],
    schedules: schedules || undefined,
  });
};

export const deleteService = async (
  serviceId: string
): Promise<AxiosResponse<ResponseDTO<ServiceDTO>>> => {
  return del(`${baseUrl}/${serviceId}`);
};

export const getMyServices = async (): Promise<
  AxiosResponse<ResponseDTO<ServiceDTO[]>>
> => {
  return get(`${baseUrl}/my`);
};

export const uploadServiceImages = async (
  files: File[]
): Promise<string[]> => {
  const formData = new FormData();
  files.forEach(file => formData.append('images', file));
  const token = localStorage.getItem('user_access_token');
  const response = await axios.post(`${baseUrl}/upload-images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

// ── Likes ──
export const toggleServiceLike = async (
  serviceId: string
): Promise<AxiosResponse<ResponseDTO<{ liked: boolean; likeCount: number }>>> => {
  return post(`${baseUrl}/${serviceId}/like`, {});
};

export const getServiceLikeStatus = async (
  serviceId: string
): Promise<AxiosResponse<ResponseDTO<{ liked: boolean; likeCount: number }>>> => {
  return get(`${baseUrl}/${serviceId}/like-status`);
};

export const getMyLikedServices = async (): Promise<
  AxiosResponse<ResponseDTO<ServiceDTO[]>>
> => {
  return get(`${baseUrl}/my-likes`);
};

export const getServicesByHost = async (
  hostId: string
): Promise<AxiosResponse<ResponseDTO<ServiceDTO[]>>> => {
  return get(`${baseUrl}/host/${hostId}`);
};
